const { defineMessages } = require('@sm/intl');

const COPY = defineMessages({
  CONTACT_US_TODAY: {
    id: 'Pricing.Enterprise.Heading',
    defaultMessage: 'Contact us today',
    desc: '[Type: header][Vis: high] - Primary header for enterprise tab contact us form',
  },
  MAIN_HEADING: {
    id: 'Pricing.MainHeading.Heading',
    defaultMessage: 'Choose a plan that works for you',
    desc: '[Type: header][Vis: high] - Primary header for pricing enterprise page',
  },
  SURVEY_MONKEY_ENTERPRISE: {
    id: 'Pricing.Enterprise.SurveyMonkeyEnterpriseHeading',
    defaultMessage: 'SurveyMonkey Enterprise',
    desc: '[Type: header][Vis: high] - Primary header for enterprise user pricing page',
  },
  LEARN_MORE: {
    id: 'Pricing.Enterprise.SubHeading',
    defaultMessage: 'Learn more about SurveyMonkey Enterprise and schedule a demo.',
    desc: '[Type: header][Vis: high] - Subheader for enterprise tab contact us form',
  },
  MANAGE_USERS: {
    id: 'Pricing.Enterprise.ManageUsersBullet',
    defaultMessage:
      'Manage multiple users and gain visibility into all survey data collected across your organization with admin controls and dashboards.',
    desc: '[Type: paragraph][Vis: high] - First bullet for enterprise tab contact us form',
  },
  CONFIDENTIAL_DATA: {
    id: 'Pricing.Enterprise.ConfidentialDataBullet',
    defaultMessage:
      'Ensure confidential data is protected with enhanced security including encryption, SSO, and features that help you remain compliant with HIPAA and GDPR.',
    desc: '[Type: paragraph][Vis: high] - Second bullet for enterprise tab contact us form',
  },
  FEEDBACK: {
    id: 'Pricing.Enterprise.FeedbackBullet',
    defaultMessage:
      'Make feedback automated and actionable by connecting to key business systems using APIs and powerful integrations, including Salesforce, Marketo, Tableau, and more.',
    desc: '[Type: paragraph][Vis: high] - Third bullet for enterprise tab contact us form',
  },
  INVALID_EMAIL: {
    id: 'Pricing.Enterprise.Invalid-Email',
    defaultMessage: 'Please enter a valid email address',
    desc: '[Type: Form][Vis.: high] - A message that is shown if the email entered is invalid',
  },
  BLOCKED_EMAIL: {
    id: 'Pricing.Enterprise.InvalidBusinessEmail',
    defaultMessage: 'Please use your business email address',
    desc: '[Type: Form][Vis.: high] - A message that is shown if a the email is not a business email',
  },
  INVALID_PHONE_NUMBER: {
    id: 'Pricing.Enterprise.Invalid-Phone-Number',
    defaultMessage: 'Please enter your phone number',
    desc: '[Type: Form][Vis.: high] - A message that is shown if the phone number is not valid',
  },
  REQUIRED: {
    id: 'Pricing.Enterprise.Required',
    defaultMessage: 'Required',
    desc: '[Type: Form][Vis.: high] - A message that is shown if a field is required to process the form',
  },
  CONTACT_SALES: {
    id: 'Pricing.Enterprise.ContactSales',
    defaultMessage: 'Contact sales',
    desc: '[Type: Button][Vis.: high] - A button/link text to contact the sales team',
  },
  HUSBPOT_FORM_ERROR: {
    id: 'Pricing.Enterprise.BackendError',
    defaultMessage: 'Unable to load form.',
    desc: '[Type: Button][Vis.: high] - A generic error message',
  },
  ERROR: {
    id: 'Pricing.Enterprise.GenericError',
    defaultMessage: 'Error',
    desc: '[Type: Button][Vis.: high] - A generic error message',
  },
  CONSENT: {
    id: 'Pricing.Enterprise.ConsentMessage',
    defaultMessage:
      'Contact me about SurveyMonkey Business Solutions like product updates, news, information, and special promotions. I can unsubscribe if I have any questions. We remember your preference so you do not have to submit it to us again and we will retain this preference until you opt-out.',
    desc: '[Type: Text][Vis.: high] - Consent to newsletter subscription verbiage',
  },
  CONSENT_ONE: {
    id: 'Pricing.Enterprise.ConsentMessageOne',
    defaultMessage: `Contact me about SurveyMonkey Business Solutions like product updates, news, information, and special promotions.
    I can unsubscribe `,
    desc: '[Type: Text][Vis.: high] - Consent to newsletter subscription verbiage one',
  },
  CONSENT_TWO: {
    id: 'Pricing.Enterprise.ConsentMessageTwo',
    defaultMessage: ` at any time and can visit SurveyMonkey's `,
    desc: '[Type: Text][Vis.: high] - Consent to newsletter subscription  verbiage two',
  },
  CONSENT_THREE: {
    id: 'Pricing.Enterprise.ConsentMessageThree',
    defaultMessage: ` if I have any questions. We remember your preference so you do not have to submit it to us again and we will retain this preference until you opt-out.`,
    desc: '[Type: Text][Vis.: high] - Consent to newsletter subscription  verbiage three',
  },
  SUBSCRIPTION_LINK: {
    id: 'Pricing.Enterprise.SubscriptionLink',
    defaultMessage: 'here',
    desc: '[Type: Checkbox][Vis.: high] - Consent link to newsletter subscription',
  },
  MP_PRIVACY_LINK: {
    id: 'Pricing.Enterprise.MPLink',
    defaultMessage: 'privacy notice',
    desc: '[Type: Checkbox][Vis.: high] - Privacy notice',
  },
});

export default COPY;
